const cookieLMDT = 'lastMovementDatetime';
const cookieLRDT = 'lastRefreshDatetime';
const INACTIVE_MINS = 15;
const EXPIRATION_MINS = 30;

export function CountDown(now: Date): string {
    const lastM = Number(readCookie(cookieLMDT));
    const nowM = now.getTime();
    const diff = ((lastM + ((EXPIRATION_MINS) * 60 * 1000)) - nowM);
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.round(((diff % 60000) / 1000));
    if (minutes <= 0 && seconds <= 0) {
        return '00:00';
    }
    return ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);
}

export function Inactivity(act: boolean): number {
    let resp = 0;
    const lastM = Number(readCookie(cookieLMDT));
    const lastR = Number(readCookie(cookieLRDT));
    const now = new Date().getTime();
    const diff = now - lastM;
    const minInactive = diff > 0 ? diff / (60 * 1000) : 0;
    const minToReview = (((now - lastR) % 86400000) % 3600000) / 60000;
    if (minInactive >= INACTIVE_MINS) {
        resp = 1;
    } else if (minToReview >= INACTIVE_MINS && !act) {
        resp = 2;
    }

    return resp;
}

export function readCookie(cookieName: string) {
    const name = cookieName + '=';
    const ca = document.cookie.split(';');
    for (let c of ca) {

        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }

    }

    return '';
}

export function SetLastMovement(datetime: Date) {
    const exp = new Date();
    exp.setUTCDate(new Date().getUTCDate() + 1);
    document.cookie = cookieLMDT + ' = ' + datetime.getTime() + '; expires= ' + exp.toUTCString() + '; path=/';
}

export function SetLastRefresh(datetime: Date) {
    const exp = new Date();
    exp.setUTCDate(new Date().getUTCDate() + 1);
    document.cookie = cookieLRDT + ' = ' + datetime.getTime() + '; expires= ' + exp.toUTCString() + '; path=/';
}

export function CleanCookies() {
    document.cookie = cookieLRDT + ' = 0; expires= ' + new Date().toUTCString() + '; path=/';
    document.cookie = cookieLMDT + ' = 0; expires= ' + new Date().toUTCString() + '; path=/';
}
